// Baked in at build time. The deployed API Gateway endpoint is the default so
// CI builds work without a local .env file; override for local backend testing.
export const API_ENDPOINT =
  import.meta.env.VITE_API_ENDPOINT ||
  'https://fwz2athz1g.execute-api.ap-southeast-2.amazonaws.com/prod/contact';
